exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.only-print {\r\n  display: none !important;\n}\n.title-print {\r\n  padding: 16px 0;\n}\n@media print {\n.only-print {\r\n    display: -webkit-box !important;\r\n    display: -ms-flexbox !important;\r\n    display: flex !important;\n}\n}\n.question-alternative {\r\n  line-break: auto !important;\r\n  text-overflow: unset !important;\r\n  white-space: normal !important;\r\n  margin-bottom: 6px !important;\r\n  font-size: 0.975rem !important;\n}\n@media print {\n.question-title {\r\n    font-size: 16px !important;\r\n    padding-bottom: 4px !important;\n}\n}\r\n", ""]);

// exports
